import classNames from 'clsx';
import { ReactComponent as CloseIcon } from 'mrg-icons/src/mailru/actions/close_big.svg';
import React, { memo, ReactElement, useCallback, useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { DataList } from 'reactApp/ui/Datalist/DataList';
import { noop } from 'reactApp/utils/helpers';
import { scrollLock, scrollUnlock } from 'reactApp/utils/scrollLock';

import styles from './DataListPopup.css';
import { IProps } from './DataListPopup.types';

const CLOSE_TIMEOUT = 100;

export const DataListPopup = memo(function DataListPopup(props: IProps): ReactElement {
    const { onClose, title, storage, viewMode, children } = props;
    const [visible, setVisible] = useState<boolean>(false);
    const rootRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = rootRef?.current;
        scrollLock(el, { reserveScrollBarGap: true });
        setVisible(true);

        return () => scrollUnlock(el);
    }, []);

    const handleClose = useCallback((): void => {
        setVisible(false);
        onClose();
    }, [onClose]);

    return (
        <CSSTransition
            in={visible}
            timeout={CLOSE_TIMEOUT}
            appear
            classNames={{
                exit: styles.animation_exit,
                exitActive: styles.animation_exit_active,
                enter: styles.animation_appear,
                enterActive: styles.animation_appear_active,
                appear: styles.animation_appear,
                appearActive: styles.animation_appear_active,
            }}
        >
            <div className={styles.root} ref={rootRef}>
                {title && (
                    <div className={classNames(styles.title, styles.title_sticky)}>
                        {title}

                        <div className={styles.close} onClick={handleClose}>
                            <CloseIcon width={14} height={14} />
                        </div>
                    </div>
                )}

                {visible && (
                    <div className={styles.datalist}>
                        <DataList storage={storage} goTo={noop} viewMode={viewMode} isPopup customScrollElement={rootRef.current} />
                    </div>
                )}
                {children}
            </div>
        </CSSTransition>
    )
});
